import { render, staticRenderFns } from "./ShowOrder.vue?vue&type=template&id=621be3bf&scoped=true"
import script from "./ShowOrder.vue?vue&type=script&lang=js"
export * from "./ShowOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621be3bf",
  null
  
)

export default component.exports